import { detect } from 'detect-browser';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from 'ViatoUi/Extranet/Surfaces/Alert';
import Dropdown from 'ViatoUi/Extranet/Surfaces/Dropdown';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';

import styles from './ErrorPanel.module.scss';

const ErrorPanel = ({ userMessage, errorCode, errorMessage }) => {
	const browser = detect();
	const { t } = useTranslation('viatoUi');

	return (
		<>
			<Alert type='error'>{userMessage}</Alert>
			<Spacer height='xs' />
			<Dropdown
				className={styles.dropdown}
				headClassName={styles.head}
				label={t('extranet.dataDisplay.errorPanel.furtherDetails')}
				transparent
			>
				<pre className={styles.info}>
					<strong>Error {errorCode}:</strong>
					<br /> {errorMessage}
					<br />
					<br />
					This error occurred on {browser.name} {browser.version}, {browser.os} <br />
					Timestamp:
					{Math.floor(Date.now() / 1000)}
				</pre>
			</Dropdown>
			<Spacer height='xs' />
		</>
	);
};

ErrorPanel.propTypes = {
	userMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	errorCode: PropTypes.number,
	errorMessage: PropTypes.string
};

ErrorPanel.defaultProps = {
	errorCode: null,
	errorMessage: null
};

export default ErrorPanel;
